module.exports = __webpack_public_path__ + "img/259.ee3a42fa.gif";